// @flow @jsx h

import { VideoPlayer as BaseVideoPlayer } from '@nrk/dh-feature-components'
import { h } from 'preact'
import PureComponent from 'preact-pure-component'

class VideoPlayer extends PureComponent<any, any> {
  elm: any

  state = {
    playing: true
  }

  componentDidMount () {
    this.props.onRegisterTriggerElement(
      this.elm,
      this.props.sectionIndex,
      this.props.index
    )
  }

  handleUserTogglePlay = () => {
    this.setState({ playing: !this.state.playing })
  }

  handlePlay = () => {
    this.props.onAnalyticsEvent({
      action: `video/PLAY/${this.props.sectionIndex}/${this.props.index}`
    })
  }

  handlePause = () => {
    this.props.onAnalyticsEvent({
      action: `video/PAUSE/${this.props.sectionIndex}/${this.props.index}`
    })
  }

  render () {
    const { playing } = this.state

    return (
      <div ref={elm => (this.elm = elm)}>
        <BaseVideoPlayer
          {...this.props}
          playing={
            this.props.isIntersecting &&
            this.props.intersectionRatio >= 0.5 &&
            playing
          }
          onPlay={this.handlePlay}
          onPause={this.handlePause}
          onUserTogglePlay={this.handleUserTogglePlay}
        />
      </div>
    )
  }
}

export default VideoPlayer



// WEBPACK FOOTER //
// ./src/v1/components/Article/VideoPlayer.js